module.exports = __webpack_public_path__ + "assets/img/star-green.webp?036b95573ec232b05aa5bfc0f50f22de";